module.exports = __webpack_public_path__ + "img/IMG_5615_P-2_L_Wood_MockedUp.cf2c584e.jpg";